// Home Specific Storage Identifiers
export const HOME_QUOTE_STORAGE = 'homeQuote';
export const HOME_QUOTE_THANK_YOU_STORAGE = 'homeQuoteThankYouPage';
export const HOME_QUOTE_RECALCULATED_VALUES_STORAGE = 'homeQuoteRecalculateData';
